import { useMemo } from 'react';
import { roundToNDecimalPlaces } from '@goldcast/player-config/src/utils/mathUtils';
import { getClipTotalDurationInFrames } from '../../utils/configUtils';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';

export default function useRemotionPlayerDuration() {
  const { clipData, fps } = useClipsContext();

  const playerDuration = useMemo(() => {
    const totalDurationInFrames = getClipTotalDurationInFrames(clipData);
    return roundToNDecimalPlaces(totalDurationInFrames / fps, 3);
  }, [clipData, fps]);

  return playerDuration;
}
